"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Loader() {
  return _react2.default.createElement(
    "div",
    { className: "loading-indicator" },
    _react2.default.createElement(
      "span",
      { className: "loading-bullet" },
      "\u2022"
    ),
    ' ',
    _react2.default.createElement(
      "span",
      { className: "loading-bullet" },
      "\u2022"
    ),
    ' ',
    _react2.default.createElement(
      "span",
      { className: "loading-bullet" },
      "\u2022"
    )
  );
}

exports.default = Loader;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-block-ui/lib/Loader.js
// module id = 2097
// module chunks = 10